import React from 'react';
import queryString from 'query-string';
import LoadingSpinner from "../../components/LoadingSpinner/index";
import SearchForm from "./components/SearchForm/index";
import MembersApi from "../../services/portal-api/MembersApi";
import Header from "../../components/Header/index";
import MemberTable from "./components/MemberTable/index";
import PageTitle from "../../components/PageTitle/index";
import NoResultFound from "./components/NoResultFound/index";
import SystemErrorMessage from "../../components/SystemErrorMessage/index";
import withAuth from "../../services/withAuth";
import {Redirect} from "react-router-dom";
import CustomerRow from "./components/MemberTable/components/CustomerRow";
import NotFound from '../NotFound';
import AuthService from '../../services/AuthService';

class MemberLookup extends React.Component {

    constructor(props) {
        super(props);
        const parsed = queryString.parse(props.location.search);
        this.state = {
            isInitialView: true, // Used to show a more Google-like search at first
            query: (typeof parsed.q !== 'undefined') ? parsed.q : '',
            sort: (typeof parsed.sort !== 'undefined') ? parsed.sort : 'surname',
            dir: (typeof parsed.dir !== 'undefined') ? parsed.dir : 'asc',
            searchedQuery: '',
            isLoading: false,
            hasResult: false, // Because members might be empty after a successful search
            members: [],
            total: 0,
            error: null,
            isCheckboxChecked: AuthService.can('country specific search ticked') ? true : false,
            countryCode: this.countryCode(),
            actualSearchKey: (parsed.actualSearchKey != '') ? parsed.actualSearchKey : '',
        };
    }

    componentDidMount() {
        document.title = 'Member Lookup - duskPortal';
        document.body.className = 'page--blue';
        console.log('actualSearchKey', this.state.actualSearchKey)
        this.navListener = this.props.history.listen((location, eventType) => {
            const parsed = queryString.parse(location.search);
            
            this.setState({
                isInitialView: (typeof parsed.q === 'undefined'),
                query: (typeof parsed.q !== 'undefined') ? parsed.q : '',
                sort: (typeof parsed.sort !== 'undefined') ? parsed.sort : 'surname',
                dir: (typeof parsed.dir !== 'undefined') ? parsed.dir : 'asc',
                actualSearchKey: (parsed.actualSearchKey != '') ? parsed.actualSearchKey : '',
            }, () => {
                this.initUi();
                const allowCachedResult = (eventType === 'POP');
                this.doSearch(allowCachedResult);
            });
        });
        this.initUi();
        this.doSearch(true);
        MembersApi.getCountry((result)=>{
            if (result.status === 401) {
                this.props.sessionExpired();
                return;
            }
        }); // just call to check token expiry
    }

    initUi() {
        if (this.state.query === '') {
            document.getElementById('query').focus();
        }
    };

    countryCode() {
        const url = window.location.href;
        if(this.getLastDomainPartFromUrl(url) === 'nz') {
            return 'NZ';
        } else {
            return 'AU';
        }
    }

    getLastDomainPartFromUrl = (url) => {
        const urlObj = new URL(url);
        const domainParts = urlObj.hostname.split(".");
        return domainParts[domainParts.length - 1];
    }

    componentWillUnmount() {
        // No longer care about any API calls in progress
        this.callId = null;

        // Unbind the nav listener
        this.navListener();
    }

    handleQueryChange = (query) => {
        this.setState({
            query: query,
            actualSearchKey: ''
        });
    };

    handleCheckboxChange = () => {
        this.setState(prevState => ({
            isCheckboxChecked: !prevState.isCheckboxChecked
        }), () => {
            if(!this.state.isCheckboxChecked) {
                const urlParams = new URLSearchParams(window.location.search);
                urlParams.delete('actualSearchKey');
                console.log(urlParams);
                const updatedUrl = window.location.pathname + '?' + urlParams.toString();
                window.history.replaceState(null, '', updatedUrl);
                this.setState({
                    query: document.getElementById('query').value
                })
            }
        });
    }

    handleSubmit = (event) => {
        // Tidy query, strip ' and " from start/end
        let query
        if(this.state.actualSearchKey != '') {
            query = this.state.actualSearchKey.replace(/^['"]+|['"]+$/g, '');
        } else {
            query = this.state.query.replace(/^['"]+|['"]+$/g, '');
        }
        
        let actualQuery = query;
        // Check if query doesn't end with 'au' or 'nz'
        if (!query.toLowerCase().endsWith('au') && !query.toLowerCase().endsWith('nz') && this.state.isCheckboxChecked) {
            this.setState({
                actualSearchKey: query
            });
            // Add countryCode from state after a space
            query += ' ' + this.state.countryCode;
        }
        this.handleQueryChange(query);
        // Update URL
        this.props.history.push('?q=' + encodeURIComponent(query) + '&actualSearchKey=' + actualQuery);
    };

    doSearch(allowCachedResult) {

        // Ensure there's a query
        if (this.state.query === '') {
            // Reset
            this.setState({
                isInitialView: true,
                isLoading: false,
                hasResult: false,
                members: [],
                total: 0,
                error: null
            });
            return;
        }

        // Show loading and reset state
        this.setState({
            isInitialView: false,
            searchedQuery: this.state.query,
            isLoading: true,
            hasResult: false,
            members: [],
            total: 0,
            error: null
        });

        // Fetch data
        this.callId = MembersApi.search(encodeURIComponent(this.state.query), this.state.sort, this.state.dir, allowCachedResult, this.state.actualSearchKey, (result, callId) => {

            // Check if we're still interesting in this response
            if (callId !== this.callId) {
                return;
            }

            // Check for auth
            if (result.status === 401) {
                this.props.sessionExpired();
                this.setState({
                    isLoading: false,
                });
                return;
            }

            if (result.success) {
                this.setState({
                    isLoading: false,
                    hasResult: true,
                    members: result.json.members,
                    total: result.json.total
                });
            }
            else {
                this.setState({
                    isLoading: false,
                    error: result.json.error
                });
            }
        });
    };

    render() {
        // Initial view (the Google homepage-like search)
        if (this.state.isInitialView) {
            return (
                <div>
                    <Header />

                    <main className="content" role="main">

                        <div className="vertab">
                            <div className="vertab--inner viewport--width">

                                <div className="container padding--100 text--center text--15">
                                
                                    <div className="icon--wrap">
                                        <svg className="icon" width="96" height="96" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 73 73"><path className="path--color" d="M45 39.3c-.7-.2-1.6-.5-2.4-.7-1.5-.4-3.1-.9-4.1-1.4v-5.9c1.5-1 4.3-3.6 4.6-9.2.8-.8 1.2-2.2 1.2-4.1 0-1.7-.3-3-.9-3.8.6-1.8 1.8-5.3 1-8.8C43.2 1.5 37.5 0 32.8 0c-4 0-9 1.1-10.8 4.2-1.6-.1-2.8.3-3.7 1.3-2 2.2-.9 6.2-.2 8.6-.4.3-.8.7-1.1 1.1-.5.8-.8 1.9-.8 3 0 2 .9 3.6 2.3 4.3.4 5.4 3.1 7.9 4.6 8.9V37c-1.7.6-3.5 1.1-5.1 1.7-7.7 2.5-13.9 4.4-15.1 8.1C1.4 51.3.1 59 0 59.3c-.1.4 0 .9.3 1.2s.7.5 1.2.5h33.8v-3h-32c.5-2.6 1.4-7.3 2.4-10.3.7-2.2 7.3-4.3 13.1-6.2 2-.7 4.2-1.3 6.2-2.1.6-.2 1-.8 1-1.4v-7.7c0-.6-.4-1.2-.9-1.4-.2-.1-3.7-1.7-3.7-7.8 0-.8-.7-1.5-1.5-1.5-.5 0-.8-.9-.8-1.5 0-.5.1-1 .3-1.3.2-.3.3-.3.4-.3.8 0 1.5-.7 1.5-1.5 0-.4-.1-.8-.4-1.6-.4-1.2-1.5-4.9-.6-5.9.3-.3 1-.4 2-.2.8.2 1.6-.3 1.8-1.1.5-1.8 4.1-3.2 8.4-3.2 4.4 0 8 1.4 8.4 3.2.7 2.6-.3 5.5-.9 7 .1.8 0 1.3 0 1.7 0 .6.4 1.2.9 1.4.3.8.3 2.8 0 3.5-.5.2-.9.8-.9 1.4 0 6.1-3.5 7.7-3.7 7.8-.6.2-1 .8-1 1.4v7.7c0 .5.3 1 .7 1.3 1.3.8 3.5 1.5 5.6 2.1.8.2 1.6.5 2.3.7l1.1-2.9zm27.6 31.1l-8.3-8.3c1.6-2.1 2.6-4.6 2.6-7.5 0-6.7-5.5-12.2-12.2-12.2s-12.2 5.5-12.2 12.2S48 66.8 54.7 66.8c2.8 0 5.4-1 7.5-2.6l8.3 8.3c.3.3.7.4 1.1.4s.8-.1 1.1-.4c.4-.5.4-1.5-.1-2.1zM61.1 61s-.1 0 0 0c-.1.1-.1.2-.2.2-1.6 1.6-3.8 2.5-6.2 2.5-4.9 0-8.9-4-8.9-8.9s4-8.9 8.9-8.9 8.9 4 8.9 8.9c.1 2.4-.9 4.5-2.5 6.2z"/></svg>
                                    </div>

                                    <h2 className="text--40 text--light text--color">Member Lookup</h2>

                                    <SearchForm
                                        isLargeLayout
                                        onQueryChange={this.handleQueryChange}
                                        onSubmit={this.handleSubmit}
                                        query={this.state.query}
                                        actualSearch={this.state.actualSearchKey}
                                    />

                                    {AuthService.can('country specific search') && 
                                        <div style={{ 
                                            display: 'flex', 
                                            justifyContent: 'flex-end', 
                                            marginTop: '-15px',
                                            marginRight: '190px',
                                            marginBottom: '20px'
                                            }}>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    checked={this.state.isCheckboxChecked}
                                                    onChange={this.handleCheckboxChange}
                                                />
                                                &nbsp; {this.state.countryCode} Members Only
                                            </label>
                                        </div>
                                    }

                                    <p>Enter a member's Rewards card number if known, or search using a combination of name, email, postcode or state. <br />E.g. 'John Smith', 'Smith 6000', 'Smith VIC', 'smith@example.com'.</p>

                                </div>

                            </div>
                        </div>

                    </main>
                </div>
            );
        }

        // If a single result, jump to view
        // If enable this, need to fix issue with it breaking the back button flow
        if (this.state.hasResult && this.state.total === 1) {
            return <Redirect to={CustomerRow.getLinkTo(this.state.members[0], encodeURIComponent(this.state.searchedQuery), encodeURIComponent(this.state.actualSearchKey))} />
        }

        // Results-table view
        let title = "Searching '" + this.state.actualSearchKey + "'...";
        if (this.state.hasResult) {
            title = "Results for '" + this.state.actualSearchKey + "'";
        }
        return (
            AuthService.can('member lookup') ?
                <div>
                    <Header />
                    <main className="content" role="main">
                        <div className="container container--wide padding--60--top clearfix">

                            <header className="header--page clearfix">

                                <PageTitle back="/" title={title} />

                            <SearchForm
                                onQueryChange={this.handleQueryChange}
                                onSubmit={this.handleSubmit}
                                query={this.state.query}
                                actualSearch={this.state.actualSearchKey}
                            />

                        </header>
                        {AuthService.can('country specific search') && 
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '5px'}}>
                                <label style={{ marginLeft: 'auto', fontSize: 15 }}>
                                    {this.state.countryCode} Members Only &nbsp; 
                                    <input
                                        type="checkbox"
                                        checked={this.state.isCheckboxChecked}
                                        onChange={this.handleCheckboxChange}
                                    />
                                </label>
                            </div>
                        }
                        
                        
                        <LoadingSpinner isVisible={this.state.isLoading}/>

                            {this.state.error !== null &&
                                <div className="margin--20--top">
                                    <SystemErrorMessage message={this.state.error} />
                                </div>
                            }

                        {this.state.hasResult && this.state.total >= 20 &&
                            <p className="margin--20--top">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" width="24" height="24" className="icon margin--10--right"><path className="path--yellow" d="M36 0C16.1 0 0 16.1 0 36s16.1 36 36 36 36-16.1 36-36S55.9 0 36 0zm-.4 12c2.9 0 5.1 2.2 5.1 5.1 0 2.7-2.2 5.1-5.2 5.1-2.7 0-5.1-2.3-5.1-5.1.1-3 2.5-5.1 5.2-5.1zm9.9 48.4H27v-3.3c4.2-.5 4.6-.8 4.6-5.9V36.9c0-4.8-.5-5-4-5.6v-3.1c4.3-.5 9.1-1.4 13.2-2.6v25.6c0 5 .4 5.3 4.7 5.9v3.3z"/></svg>
                                Your search returned {this.state.total.toLocaleString()} results. Only the first 20 are shown. Add more detail to narrow results (e.g. postcode).
                            </p>
                        }
                    </div>
                        {this.state.hasResult &&
                            <MemberTable members={this.state.members} query={this.state.query} actualSearchKey={this.state.actualSearchKey} />
                        }

                            {this.state.hasResult && this.state.members.length === 0 &&
                                <NoResultFound />
                            }

                    </main>
                </div>
            : <NotFound forbidden={true} />
        )
    }
}

export default withAuth(MemberLookup);
